import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when user entered invalid credentials.
 */
export class InvalidLoginException extends CoreUiException {

    constructor(originalError?: any) {

        super("InvalidLogin", "Your email or password is incorrect.", originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, InvalidLoginException.prototype);
    }
}
